import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaChild, ISchemaProperty } from "../Schema";
import { NotEmptyString, NotNullOrUndefined } from "../../../../Validation/Validation";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import { IForm } from "../Form/Form";
import { hasPermission } from "../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../modules/auth/Permissions/PermissionStrings";

export const FileUploadSchema: ISchema = {
    displayName: "Documentation",
    httpContentType: "multipart/form-data",
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'concern',
            displayName: 'Concern',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
            formValueResolver: (form: IForm) => form.entityName
        } as ISchemaProperty,
        {
            name: 'title',
            displayName: 'Title',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12",
            validateRule: NotEmptyString as Function,
            validationError: "Title cannot be empty",
        } as ISchemaProperty,
        {
            name: 'description',
            displayName: 'Description',
            type: PropertyTypes.textArea,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
            className: "small-12",
            autocomplete: "off"
        } as ISchemaProperty,
        {
            name: 'file',
            displayName: 'File',
            type: PropertyTypes.fileUpload,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12",
            validateRule: NotNullOrUndefined as Function,
            validationError: "File is required",
        } as ISchemaProperty,
        {
            name: 'url',
            displayName: 'Url',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false
        } as ISchemaProperty,
        {
            name: 'fileSize',
            displayName: 'File size',
            type: PropertyTypes.number,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false
        } as ISchemaProperty,
        {
            name: 'fileSizeFormatted',
            displayName: 'File size',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false
        } as ISchemaProperty,
    ],

    children: [
        { entityName: EntityNames.sop, displayName: "SOP", cantView: false, viewType: EntityViewTypes.documentList, enableFilters: true, canAdd: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Manage_Documentation)) } as ISchemaChild,
        { entityName: EntityNames.certifications, displayName: "Certifications / Licenses", cantView: false, viewType: EntityViewTypes.documentList, enableFilters: true, canAdd: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Manage_Documentation)) } as ISchemaChild,
        { entityName: EntityNames.manuals, displayName: "Manuals", cantView: true, viewType: EntityViewTypes.documentList } as ISchemaChild,
    ],
};
